// Phase 14 — SE's own targets on mobile
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Target as TargetIcon } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

function Bar({ pct, onTrack }) {
  const cls = onTrack ? "bg-emerald-500" : "bg-rose-500";
  return (
    <div className="w-full h-2 bg-neutral-100 rounded-full overflow-hidden">
      <div className={`h-full ${cls}`} style={{ width: `${Math.min(100, pct || 0)}%` }} />
    </div>
  );
}

export default function MyTargets() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/targets/mine").then(r => setItems(r.data.items || [])).finally(() => setLoading(false));
  }, []);
  return (
    <div className="max-w-lg mx-auto p-4 space-y-3" data-testid="my-targets-page">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={() => nav(-1)}><ArrowLeft className="w-4 h-4 mr-1" /> Back</Button>
        <h1 className="font-semibold flex-1">My Targets</h1>
      </div>
      {loading ? <div className="text-neutral-500 text-sm">Loading…</div>
       : items.length === 0
         ? <div className="text-neutral-500 border border-dashed rounded-lg p-8 text-center">No active targets.</div>
         : items.map(t => (
           <div key={t.id} className="border rounded-lg p-3 bg-white" data-testid={`my-target-${t.id}`}>
             <div className="flex items-start gap-2">
               <TargetIcon className="w-4 h-4 text-[#E5197F] mt-0.5" />
               <div className="flex-1 min-w-0">
                 <div className="font-medium truncate">{t.dimension.replace(/_/g, " ")}</div>
                 <div className="text-xs text-neutral-500">{t.period_key}</div>
               </div>
               <div className="text-right">
                 <div className="text-base font-semibold">{(t.achievement_pct ?? 0).toFixed(0)}%</div>
                 <div className="text-[10px] text-neutral-500">{t.on_track ? "on track" : "off track"}</div>
               </div>
             </div>
             <div className="mt-2"><Bar pct={t.achievement_pct} onTrack={t.on_track} /></div>
             <div className="text-xs text-neutral-500 mt-1">
               ₹{Number(t.achieved_value ?? 0).toLocaleString("en-IN")} of ₹{Number(t.target_value).toLocaleString("en-IN")}
             </div>
           </div>
         ))}
    </div>
  );
}
